module.exports = __webpack_public_path__ + "static/way_of_the_astral_self-7706495dcecde46e84e47ecd2d027200.png";